export default __webpack_public_path__ + "static/media/artandpublic.b95d46de.png";